import { createSlice } from "@reduxjs/toolkit";
import {
  GetEventCheckInAction,
  GetEventDetailAction,
  GetEventList,
} from "store/middlewares/dataManagement/eventlisting";

export const eventlistingSlice = createSlice({
  name: "eventlisting",
  initialState: {
    eventlistingLoading: true,
    eventlisting: null,
    eventDetail: null,
    eventDetailLoading: true,
    eventCheckIn: null,
    eventCheckInLoading: true,
  },
  extraReducers(builder) {
    builder
      .addCase(GetEventList.pending, (state) => {
        state.eventlisting =
          state.eventlisting?.result?.length > 0 ? state.eventlisting : null;
      })
      .addCase(GetEventList.fulfilled, (state, action) => {
        state.eventlistingLoading = false;
        state.eventlisting = action.payload.response;
      })
      .addCase(GetEventList.rejected, (state) => {
        state.eventlistingLoading = false;
        state.eventlisting = null;
      })
      .addCase(GetEventDetailAction.pending, (state) => {
        state.eventDetailLoading = true;
        state.eventDetail = null;
      })
      .addCase(GetEventDetailAction.fulfilled, (state, action) => {
        state.eventDetailLoading = false;
        state.eventDetail = action.payload.response;
      })
      .addCase(GetEventDetailAction.rejected, (state) => {
        state.eventDetailLoading = false;
        state.eventDetail = null;
      })
      // check-in listing (keeps old rows while paging so the table doesn't flash)
      .addCase(GetEventCheckInAction.pending, (state) => {
        state.eventCheckIn =
          state.eventCheckIn?.result?.length > 0 ? state.eventCheckIn : null;
      })
      .addCase(GetEventCheckInAction.fulfilled, (state, action) => {
        state.eventCheckInLoading = false;
        state.eventCheckIn = action.payload.response;
      })
      .addCase(GetEventCheckInAction.rejected, (state) => {
        state.eventCheckInLoading = false;
        state.eventCheckIn = null;
      });
  },
});

export default eventlistingSlice.reducer;